import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  card: {
    display: 'flex',
    width: '100%',
    height: '100%',
    flexDirection: 'column',
    alignItems: 'center',
    padding: 0
  },
  imageContainer: {
    height: 200,
    width: '100%',
    overflow: 'hidden',
    cursor: 'pointer'
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover'
  },
  content: {
    width: '100%',
    padding: theme.spacing(4)
  },
  row: {
    flexWrap: 'nowrap'
  },
  rowLabel: {
    color: theme.colorPalette.green_75,
    fontSize: '10px',
    fontWeight: 600,
    lineHeight: '12px',
    textTransform: 'uppercase',
    fontFamily: theme.typography.fontFamily
  },
  rowText: {
    color: theme.colorPalette.green_80,
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  originalFileName: {
    fontSize: '12px',
    lineHeight: '16px',
    fontStyle: 'italic',
    color: theme.colorPalette.beige_75
  },
  actionIconContainer: {
    display: 'flex',
    alignItems: 'center',
    margin: 'auto 0',
    height: '100%',
    padding: 0
  },
  actionIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 24,
    width: 24
  },
  tooltip: {
    backgroundColor: theme.colorPalette.green_75
  }
}));

export default useStyles;
